export enum MatchingStatus {
  PossibleMatch = 'PossibleMatch',
  ReviewedBlocked = 'Reviewed - Blocked',
  ReviewedNoActionNeeded = 'Reviewed - No Action Needed'
}
